'use client'

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { ProductFormatted } from '@/types/product'
import { ProductCard } from '../product-card'

type Props = {
  products: ProductFormatted[]
}

export function ProductCarousel({ products }: Props) {
  if (!products.length) return <EmptyProductCarousel />

  return (
    <div className='relative'>
      <Carousel
        opts={{
          align: 'start',
          duration: 50,
          slidesToScroll: 2,
          skipSnaps: true,
          loop: true,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          watchDrag: (_, event: any) => {
            const target = event?.target as HTMLElement
            const wrapper = target?.closest(
              '.color-variant-picker-wrapper'
            ) as HTMLElement | null

            if (wrapper) {
              const hasScroll = wrapper.scrollWidth > wrapper.clientWidth
              if (hasScroll) {
                return false // Chặn drag khi wrapper có scroll ngang
              }
            }

            return true // Cho phép drag nếu không có scroll
          },
        }}
        className='w-full'
      >
        <CarouselContent className='-ml-3'>
          {products.map((product, index) => (
            <CarouselItem
              key={product.id + index}
              className='basis-1/2 will-change-transform md:basis-1/3 lg:basis-1/4 xl:basis-1/5'
              data-product-id={product.id}
            >
              <ProductCard product={product} />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselNavigation />
      </Carousel>
    </div>
  )
}

// Extracted components for better organization
function CarouselNavigation() {
  return (
    <>
      <CarouselPrevious
        className='absolute -left-4 top-1/2 h-7 w-7 -translate-y-full lg:-left-10'
        variant='black'
        hideIfStart
      />
      <CarouselNext
        className='absolute -right-4 top-1/2 h-7 w-7 -translate-y-full lg:-right-10'
        variant='black'
        hideIfEnd
      />
    </>
  )
}

function EmptyProductCarousel() {
  return (
    <div className='p-4 text-center'>
      <p className='text-sm text-muted-foreground'>Không có sản phẩm nào</p>
    </div>
  )
}
